module.exports = __webpack_public_path__ + "static/media/start-project.5a0a0f8a.png";